import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HubService {

    // Observable string sources
    public HubCallEventsSource = new Subject<string>();
    userDetails: any;
    TMHubJoined: boolean=false;
    IsHubStarted: boolean = false;
    // Observable string streams
    public InboundCallEvents = this.HubCallEventsSource.asObservable();
  

    // Service message commands
    public setCallEvents(val: any) {
        this.HubCallEventsSource.next(val);
    }


    setuserDetails(value: any) {
        this.userDetails=value;
    }

    getuserDetails() {
       
        return this.userDetails;
    }

    setTMHubJoinedStatus(value: boolean) {
        this.TMHubJoined = value;
    }

    getTMHubJoinedStatus() {

        return this.TMHubJoined;
    }

    setIsHubStarted(value: boolean) {
        this.IsHubStarted = value;
    }

    getIsHubStarted() {

        return this.IsHubStarted;
    }
   
}